import { Outlet } from 'react-router-dom';

import { CVAnalysisResultLayoutProvider } from '@/features/cv-analysis-result';
import { GuardCVAnalysis } from '@/features/auth';

export const CVAnalysisResultLayout = () => {
  return (
    <GuardCVAnalysis>
      <CVAnalysisResultLayoutProvider>
        <Outlet />
      </CVAnalysisResultLayoutProvider>
    </GuardCVAnalysis>
  );
};
